import { Result } from 'antd';

const Error = ({ error }: { error?: string }) => {
  return (
    <Result
      status="error"
      title="Error happened"
      subTitle={error || 'An unexpected error occurred. Please try again.'}
    />
  );
};

export default Error;
